import { createFileRoute } from "@tanstack/react-router";
import { PointsHelpTemplate } from "~/features/myProfile/PointsHelpTemplate";

export const Route = createFileRoute("/_authenticated/profile/points-help")({
  component: PointsHelpTemplate,
});
